<template>
  <pet-form
    :initPet="initPet"
    :successMsg="t('created')"
    :submitAction="submit"
    enableClearForm
    clearFormOnSubmit
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PetForm from '@/views/pets/PetForm.vue'

import Pet from '@/models/Pet'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'new-pet',

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          created: 'Pet was created successfully'
        },
        ar: {
          created: 'تم إنشاء الأليف بنجاح'
        }
      }
    })

    return { t }
  },

  components: {
    PetForm
  },
  data() {
    return {
      initPet: new Pet()
    }
  },

  methods: {
    async submit(pet: Pet) {
      try {
        await this.$http.post(Pet.ENDPOINT, pet)
        await this.$router.push(this.$Route.PETS)
      } catch (error) {
        return error
      }
    }
  }
})
</script>

<style></style>
